$('span.shareButton').click(function (e) {
    e.preventDefault();
    const $link = $(this);
    const href = $link.attr('data-href');
    const network = $link.attr('data-network');

    const networks = {
        facebook: {width: 600, height: 300},
        google: {width: 515, height: 490},
        tumblr: {width: 500, height: 500},
        pinterest: {width: 800, height: 600},
        twitter: {width: 600, height: 254},
        reddit: {width: 600, height: 300},
        linkedin: {width: 600, height: 473},
        digg: {width: 800, height: 500},
        delicious: {width: 800, height: 600},
        stumbleupon: {width: 800, height: 600},
        russiansm1: {width: 800, height: 600},
        russiansm2: {width: 800, height: 600}
    };
    const popup = function (network) {
        const options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
        window.open(href, '', options + 'height=' + networks[network].height + ',width=' + networks[network].width);
    }
    popup(network);
});
